export const FETCH_BOOKMARKS_REQUEST = "FETCH_BOOKMARKS_REQUEST";
export const FETCH_BOOKMARKS_SUCCESS = "FETCH_BOOKMARKS_SUCCESS";
export const FETCH_BOOKMARKS_FAILURE = "FETCH_BOOKMARKS_FAILURE";

export const ADD_BOOKMARK_REQUEST = "ADD_BOOKMARK_REQUEST";
export const ADD_BOOKMARK_SUCCESS = "ADD_BOOKMARK_SUCCESS";
export const ADD_BOOKMARK_FAILURE = "ADD_BOOKMARK_FAILURE";

export const REMOVE_BOOKMARK_REQUEST = "REMOVE_BOOKMARK_REQUEST";
export const REMOVE_BOOKMARK_SUCCESS = "REMOVE_BOOKMARK_SUCCESS";
export const REMOVE_BOOKMARK_FAILURE = "REMOVE_BOOKMARK_FAILURE";